import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink, FiStar } = FiIcons;

const ProductCard = ({ product, onClick, onCategoryClick }) => {
  const handleClick = () => {
    onClick(product);
  };
  
  const handleCategoryClick = (e, category) => {
    e.stopPropagation();
    if (onCategoryClick) {
      onCategoryClick(category);
    }
  };

  return (
    <motion.div
      whileHover={{ y: -2 }}
      className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden cursor-pointer hover:shadow-md transition-all duration-200 h-full flex flex-col"
      onClick={handleClick}
    >
      <div className="p-4 flex flex-col flex-grow">
        {/* Product Image - Left aligned */}
        {product.logo && (
          <div className="flex justify-start mb-3">
            <img
              src={product.logo}
              alt={product.name}
              className="w-32 h-32 object-contain rounded border border-gray-200"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        )}

        {/* Header */}
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-gray-900 text-[1.2rem] mb-1 break-words">
              {product.name || 'Unnamed Product'}
            </h3>
          </div>
          {product.featured && (
            <SafeIcon icon={FiStar} className="text-yellow-500 text-sm flex-shrink-0 ml-2" />
          )}
        </div>

        {/* Tagline - Now bold and colored */}
        {product.tagline && (
          <p className="text-sm font-bold text-[#8d2424] mb-3 break-words">
            {product.tagline}
          </p>
        )}

        {/* Categories - With border and increased font weight - text-left added */}
        {product.categories && (
          <div className="flex flex-wrap gap-1 mb-3">
            {product.categories
              .split(',')
              .slice(0, 2)
              .map((category, index) => (
                <button 
                  key={index}
                  onClick={(e) => handleCategoryClick(e, category.trim())}
                  className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs font-medium border border-black hover:bg-gray-200 transition-colors text-left"
                >
                  {category.trim()}
                </button>
              ))}
            {product.categories.split(',').length > 2 && (
              <span className="text-xs text-gray-500">
                +{product.categories.split(',').length - 2} more
              </span>
            )}
          </div>
        )}

        {/* Footer - push to bottom with flex-grow */}
        <div className="flex items-center justify-between pt-2 border-t border-gray-100 mt-auto">
          <span className="text-xs text-primary-600 font-medium">View Details</span>
          {product.url && (
            <SafeIcon icon={FiExternalLink} className="text-gray-400 text-xs" />
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;